

































































































































import Vue from 'vue';
import _ from 'lodash';

import moment from 'moment-timezone';
import Requester from '../../requester';

import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { TipoParto, SexoBebe } from '../../../../back/src/types';
import { tipoPartoStrings, sexoBebeIcons } from '../../utils/constants';

import Confirmar from '../Confirmar.vue';
import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import TheGestacoesDadosFinalizada from './TheGestacoesDadosFinalizada.vue';
import { calculoIdadeGestacional } from '../../utils/functions';

export default Vue.extend({
  name: 'TheGestacoesTabelaFinalizadas',
  components: {
    Confirmar,
    CustomDialog,
    IfEmptyTextPrintNA,
    TheGestacoesDadosFinalizada,
  },
  props: {
    gestacoes: {
      type: Array as () => Gestacao[],
    },
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      dialogGestacaoDados: false,
      gestacaoSelecionada: null,
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          value: 'data_parto',
          text: 'Data',
          sortable: true,
        },
        {
          value: 'ig',
          text: 'IG',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'tipo_parto',
          text: 'Tipo',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'bebes',
          text: 'Bebê(s)',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'observacoes',
          text: 'Observações',
          sortable: false,
        },
        {
          value: 'detalhes',
          text: 'Detalhes',
          sortable: false,
          align: 'center',
        },
        {
          value: 'prenatal',
          text: 'Carteira P.N.',
          sortable: false,
          align: 'center',
        },
        {
          value: 'remover',
          text: 'Remover',
          sortable: false,
          align: 'center',
        },
      ];
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
  },
  methods: {
    idadeGestacional(gestacao: Gestacao) {
      if (gestacao.parto && gestacao.parto.tipo_parto === TipoParto.A) {
        return gestacao.parto.ig_aborto_semanas;
      }
      if (gestacao.gestacao_anterior) {
        let igString = '';
        if (!!gestacao.ig_semanas && gestacao.ig_semanas > 0) {
          igString = igString.concat(`${gestacao.ig_semanas}`);
        }
        if (!!gestacao.ig_dias && gestacao.ig_dias > 0) {
          igString = igString.concat(` ${gestacao.ig_dias}/7`);
        }
        return igString;
      }
      return calculoIdadeGestacional(gestacao, _.get(gestacao, 'parto.data_parto', null));
    },
    pesoFormatado(pesoGramas: number): string {
      if (pesoGramas) {
        return `${new Intl.NumberFormat('pt-BR').format(pesoGramas)} g`;
      }
      return '';
    },
    sexoBebeIcon(sexoBebe: SexoBebe) {
      if (_.has(sexoBebeIcons, sexoBebe)) {
        return sexoBebeIcons[sexoBebe];
      }
      return '';
    },
    tipoPartoString(tipoParto: TipoParto) {
      if (_.has(tipoPartoStrings, tipoParto)) {
        return tipoPartoStrings[tipoParto];
      }
      return '';
    },
    selecionaGestacao(gestacao: Gestacao) {
      this.gestacaoSelecionada = gestacao;
      this.dialogGestacaoDados = true;
    },
    async excluirGestacao(gestacao: Gestacao) {
      if (await this.confirmar.open(
        'Remover gestação',
        'Tem certeza que deseja remover esta gestação anterior?\nEsta ação é irreversível.',
      ) === false) {
        return;
      }
      try {
        const response = await Requester.gestacao.removeGestacao(gestacao.id as number);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('remove-gestacao', gestacao);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Gestação removida com sucesso.' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
    async donwloadCarteiraPreNatal(gestacaoId: number) {
      this.loading = true;
      try {
        const response = await Requester.paciente.carteiraPreNatal(
          this.paciente.id,
          gestacaoId,
        );
        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Carteira de Pré-Natal - ${this.paciente.nome} - ${moment().format('DD_MM_YYYY')}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$root.$emit('requestError', error);
      } finally {
        this.loading = false;
      }
    },
    obsTruncate(obs: string | null) {
      if (obs === null) {
        return '';
      }
      return `${obs.substr(0, 32)}${obs.length > 32 ? '...' : ''}`;
    },
    gestacaoFinalizadaAtualizada(gestacao: Gestacao) {
      this.$emit('gestacao-finalizada-atualizada', gestacao);
      this.dialogGestacaoDados = false;
    },
  },
});
